// This function is a duplicate of the one in the businessupgrades-businessapp repo (we will at some point refactor them out to a shared package).
// This is to ensure we always have the same result when calculating days remaining on a trial in both the /trial-dashboard page and nav sidebar.
// https://github.com/trustpilot/businessupgrades-businessapp/blob/040d93c537059f5fa02d504d60633dab35358891/app/routes/trial-dashboard/utils.ts#L8

export const getTrialDaysRemaining = (
  subscriptionStartDate: string,
  trialDuration: number,
  now: Date = new Date(),
): number => {
  const trialEndDate = new Date(subscriptionStartDate);

  const end = new Date(trialEndDate.toDateString());
  const today = new Date(now.toDateString());

  const msPerDay = 1000 * 60 * 60 * 24;
  const timeDiff = end.getTime() - today.getTime();

  const daysRemaining = Math.ceil(timeDiff / msPerDay);

  const positiveDaysRemaining = Math.max(0, daysRemaining);

  return positiveDaysRemaining > trialDuration ? trialDuration : positiveDaysRemaining;
};
